// User-supplied Vatican text. The repeated responses are written out for prayer.
// Keep the page, homepage and print edition tied to this single source.
export const LITANY_OF_LORETO = {
  sourceUrl: "https://www.vatican.va/special/rosary/documents/litanie-lauretane_en.html",
  sourceLabel: "Vatican · The Litany of Loreto",
  opening: ["Lord have mercy.", "Christ have mercy.", "Lord have mercy.", "Christ hear us.", "Christ graciously hear us."],
  trinity: ["God, the Father of heaven", "God the Son, Redeemer of the world", "God the Holy Spirit", "Holy Trinity, one God"],
  invocations: [
    "Holy Mary", "Holy Mother of God", "Holy Virgin of virgins",
    "Mother of Christ", "Mother of the Church", "Mother of Mercy",
    "Mother of divine grace", "Mother of Hope", "Mother most pure",
    "Mother most chaste", "Mother inviolate", "Mother undefiled",
    "Mother most amiable", "Mother most admirable", "Mother of good counsel",
    "Mother of our Creator", "Mother of our Saviour",
    "Virgin most prudent", "Virgin most venerable", "Virgin most renowned",
    "Virgin most powerful", "Virgin most merciful", "Virgin most faithful",
    "Mirror of justice", "Seat of wisdom", "Cause of our joy",
    "Spiritual vessel", "Vessel of honour", "Singular vessel of devotion",
    "Mystical rose", "Tower of David", "Tower of ivory", "House of gold",
    "Ark of the covenant", "Gate of heaven", "Morning star",
    "Health of the sick", "Refuge of sinners", "Solace of Migrants",
    "Comfort of the afflicted", "Help of Christians",
    "Queen of Angels", "Queen of Patriarchs", "Queen of Prophets",
    "Queen of Apostles", "Queen of Martyrs", "Queen of Confessors",
    "Queen of Virgins", "Queen of all Saints", "Queen conceived without original sin",
    "Queen assumed into heaven", "Queen of the most holy Rosary",
    "Queen of families", "Queen of peace",
  ],
  lambInvocation: "Lamb of God, who takes away the sins of the world,",
  lambResponses: ["spare us, O Lord.", "graciously hear us, O Lord.", "have mercy on us."],
  versicle: "Pray for us, O holy Mother of God.",
  versicleResponse: "That we may be made worthy of the promises of Christ.",
  collect: `Let us pray.
Grant, we beseech thee,
O Lord God,
that we, your servants,
may enjoy perpetual health of mind and body;
and by the glorious intercession of the Blessed Mary, ever Virgin,
may be delivered from present sorrow,
and obtain eternal joy.
Through Christ our Lord.
Amen.`,
};

export const LORETO_TEXT = [
  LITANY_OF_LORETO.opening.join("\n"),
  LITANY_OF_LORETO.trinity.map((line) => `${line},\nhave mercy on us.`).join("\n"),
  LITANY_OF_LORETO.invocations.map((line, i, all) => `${line}${i === all.length - 1 ? "." : ","}\npray for us.`).join("\n"),
  LITANY_OF_LORETO.lambResponses.map((response) => `${LITANY_OF_LORETO.lambInvocation}\n${response}`).join("\n"),
  `${LITANY_OF_LORETO.versicle}\n${LITANY_OF_LORETO.versicleResponse}`,
  LITANY_OF_LORETO.collect,
].join("\n\n");